interface IIcon {
  width?: string;
  color?: string;
  height?: string;
}
const WarningTriFileIcon = ({ width = '16', color = '#AAAAAA', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_528_8796)">
      <path
        d="M13.6748 4.0625C13.4159 4.0625 13.2061 3.85262 13.2061 3.59375V0H6.4873C5.7119 0 5.08105 0.630844 5.08105 1.40625V6.64653V7.75C5.08105 7.75 5.2998 8 6.7998 8.5H14.6123C14.8712 8.5 15.0811 8.70988 15.0811 8.96875C15.0811 9.22762 14.8712 9.4375 14.6123 9.4375H7.2998C7.5928 10.0092 8.23915 10.6427 8.2998 11.3125H14.6123C14.8712 11.3125 15.0811 11.5224 15.0811 11.7812C15.0811 12.0401 14.8712 12.25 14.6123 12.25H9.2998C9.75721 14 10.6845 14.5938 10.1419 16H15.8623C16.6377 16 17.2686 15.3692 17.2686 14.5938V4.0625H13.6748ZM14.6123 6.625H7.7373C7.47843 6.625 7.26855 6.41512 7.26855 6.15625C7.26855 5.89738 7.47843 5.6875 7.7373 5.6875H14.6123C14.8712 5.6875 15.0811 5.89738 15.0811 6.15625C15.0811 6.41512 14.8712 6.625 14.6123 6.625Z"
        fill={color}
      />
      <path d="M14.1436 0.274414V3.12495H16.9939L14.1436 0.274414Z" fill={color} />
      <path
        d="M5.9541 9.44777C5.79458 9.16781 5.50699 9.00043 5.18477 9C5.18437 9 5.18397 9 5.18357 9C4.86185 9 4.57436 9.16655 4.41431 9.44575L1.41859 14.6723C1.25947 14.9499 1.26026 15.281 1.42068 15.5578C1.58109 15.8347 1.86792 16 2.18792 16H8.16115C8.48065 16 8.76725 15.8351 8.92779 15.5588C9.08834 15.2826 9.08977 14.9519 8.93161 14.6743L5.9541 9.44777ZM5.23499 14.9966C4.95605 14.9966 4.7495 14.7686 4.73743 14.4991C4.72538 14.2303 4.97473 14.0015 5.23499 14.0015C5.51392 14.0015 5.72047 14.2295 5.73255 14.4991C5.74456 14.7678 5.49525 14.9966 5.23499 14.9966ZM5.73255 12.6659C5.73255 12.9448 5.50457 13.1514 5.23499 13.1634C4.96627 13.1755 4.73743 12.9261 4.73743 12.6659C4.73743 12.1187 4.73743 11.5716 4.73743 11.0244C4.73743 10.7455 4.96541 10.5389 5.23499 10.5269C5.5037 10.5148 5.73255 10.7642 5.73255 11.0244V12.6659Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_528_8796">
        <rect width="16" height="16" fill="white" transform="translate(0.799805)" />
      </clipPath>
    </defs>
  </svg>
);

export default WarningTriFileIcon;
